<template>
	<div>
		<SupportBanner />
		<div class="content-zsy">
			<div class="board-write">
				<h3>1:1문의</h3>
				
				<el-row class="list list-top">
					<el-col class="item-title" :span="7">
						주문서 선택
					</el-col>
					<el-col class="item-content" :span="17">
						<div v-if="selectedOrder" style="margin-bottom: 10px; font-weight: bold; color: #409EFF;">
							[선택된 주문] {{ selectedOrder.goods_name }} ({{ selectedOrder.platform_order_no }})
							<el-button type="text" style="color: #f56c6c; margin-left: 10px;" @click="selectedOrder = null">취소</el-button>
						</div>
						<el-button type="primary" plain @click="openOrderDialog" >{{ selectedOrder ? '다시 선택' : '선택하기' }}</el-button>
					</el-col>
				</el-row>
				<el-dialog
				  title="주문서 선택"
				  :visible.sync="dialogVisible"
				  width="80%"
				  >
				  <div class="search-bar" style="margin-bottom: 20px;">
					<el-input placeholder="주문번호 검색(1688/taobao)" v-model="searchForm.k" @keyup.enter.native="onSearch" style="width: 300px;">
					  <el-button slot="append" icon="el-icon-search" @click="onSearch"></el-button>
					</el-input>
				  </div>
				  <el-table :data="tableData" v-loading="loading" height="400" empty-text="데이타가 없습니다." style="width: 100%;">
				    <el-table-column label="상태" width="100">
				      <template slot-scope="scope">
				        <div style="color:#67C23A;">[{{scope.row.inventory_status}}]</div>
				        <div style="font-size: 12px;">{{ scope.row.status_name }}</div>
				      </template>
				    </el-table-column>
				    <el-table-column label="사진" width="80">
				      <template slot-scope="scope">
				        <el-image 
				          style="width: 50px; height: 50px; border-radius: 4px; border: 1px solid #eee;"
				          :src="scope.row.goods_image ? (scope.row.goods_image.startsWith('//') ? 'https:' + scope.row.goods_image : scope.row.goods_image) : SERVER_URL + '/assets/img/no_thumb.png'"
				          fit="cover">
				        </el-image>
				      </template>
				    </el-table-column>
				    <el-table-column label="상품정보" min-width="200">
				      <template slot-scope="scope">
				        <div style="font-weight: bold; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">{{ scope.row.goods_name }}</div>
				        <div style="font-size: 12px; color: #999;">
				          <span style="margin-right: 10px;">¥{{scope.row.price}}</span>
				          <span>{{ scope.row.apply_quantity }} 개</span>
				        </div>
				      </template>
				    </el-table-column>
				    <el-table-column label="주문번호" width="320">
				      <template slot-scope="scope">
				        <div>{{ scope.row.platform_order_no }}</div>
						<!-- {{ scope.row.platform_order_no || scope.row.order_no }} -->
				      </template>
				    </el-table-column>
				    <el-table-column label="선택" width="100">
				      <template slot-scope="scope">
				        <el-button size="mini" type="success" @click="selectOrder(scope.row)">선택</el-button>
				      </template>
				    </el-table-column>
				  </el-table>
				  <div style="text-align: center; margin-top: 20px;">
				    <el-pagination
				      layout="prev, pager, next"
				      :current-page.sync="page"
				      :page-size="20"
				      :total="total"
				      @current-change="handleCurrentChange">
				    </el-pagination>
				  </div>
				  <span slot="footer" class="dialog-footer">
				    <el-button @click="dialogVisible = false">닫기</el-button>
				  </span>
				</el-dialog>

				<el-row class="list">
					<el-col class="item-title" :span="7">
						카테고리
					</el-col>
					<el-col class="item-content" :span="17">
						<el-select v-model="cate_value" @change="categoryChange" class="category"  placeholder="카테고리">
						    <el-option 
						      v-for="item in category"
						      :key="item.id"
						      :label="item.cate_name"
						      :value="item.id">
						    </el-option>
						</el-select>
					</el-col>
				</el-row>
				<el-row class="list">
					<el-col class="item-title" :span="7">
						제목
					</el-col>
					<el-col class="item-content" :span="17">
						<el-input v-model="title" placeholder="제목을 입력해주세요"></el-input>
					</el-col>
				</el-row>
				<div style="border: 1px solid #ccc;margin:20px 10px 0;">
					<Toolbar
						style="border-bottom: 1px solid #ccc"
						:editor="editor"
						:defaultConfig="toolbarConfig"
						:mode="mode"
					/>
					<Editor
						style="height: 400px; overflow-y: hidden;"
						v-model="html"
						:defaultConfig="editorConfig"
						:mode="mode"
						@onCreated="onCreated"
					/>
				</div>
				<div class="" style="padding:20px;display: flex;">
					<el-upload
					  class=""
					  :action="update_url+'/common/upload'"
					  :before-upload="beforeAvatarUpload"
					  :on-preview="handlePreview"
					  :on-remove="handleRemove"
					  :before-remove="beforeRemove"
					  :on-success="handleAvatarSuccess"
					  multiple
					  :limit="3"
					  :on-exceed="handleExceed"
					  :file-list="fileList">
					  <el-button size="small" type="primary">+ 파일을 선택하세요.</el-button>
					  <div slot="tip" class="el-upload__tip">파일 크기는 1MB를 초과할 수 없습니다.</div>
					</el-upload>
					
				</div>
				<div class="submit">
					<el-button round @click="cancel">작성취소</el-button>
					<el-button type="primary" round @click="submit">저장하기</el-button>
				</div>
				
				
			</div>
			
		</div>
		
	</div>
</template>

<script>
	import request from '@/utils/request'
	import { Editor, Toolbar } from '@wangeditor/editor-for-vue'
	import { i18nChangeLanguage } from '@wangeditor/editor'
	i18nChangeLanguage('en')// 'en' 或 'zh-CN'
	import SupportBanner from '../../components/SupportBanner.vue'
	import Constants from '@/constants'
	export default {
		components: {
			SupportBanner, Editor, Toolbar
		},
		data() {
		    return {
		        editor: null,
		        html: '',//<p>hello</p>
		        toolbarConfig: {},
		        editorConfig: { placeholder: '문의 내용을 입력하십시오...' },
		        mode: 'default', //'default' or 'simple'
				
				dialogVisible: false,
				cate_value:'',
				category: [],
				//cate_id:'',
				title:'',
				
				fileList: [],
				file_url:[],
				update_url:'',
				SERVER_URL: '',
				
				// 订单选择相关
				tableData: [],
				total: 0,
				page: 1,
				loading: false,
				searchForm: {
					s: 'orderNo',
					k: '',
					deliveryLock: '',
					date1: '',
					date2: '',
				},
				selectedOrder: null,
		    }
		},
		methods: {
			//文件上传成功时的钩子
			handleAvatarSuccess(res, file) {
				console.log(res,11)
				console.log(file,22)
				if(res.code ==1){
					console.log(file.name,33);
					console.log(res.data.url,33);
					this.file_url.push({name: file.name, url: res.data.url})
				
				}
				console.log(this.file_url,33);
				//this.imageUrl = URL.createObjectURL(file.raw);
			  },
			//文件列表移除文件时的钩子
			handleRemove(file, fileList) {
				console.log(file, fileList);
			  },
			  //点击文件列表中已上传的文件时的钩子	
			  handlePreview(file) {
				console.log(file);
				//window.open(file.url,'_blank');
				if(file.response.code ==1){
					window.open(file.response.data.fullurl,'_blank');
				}
				//window.open(file.url,'_blank');
			  },
			  //文件超出个数限制时的钩子
			  handleExceed(files, fileList) {
				this.$message.warning(`当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
			  },
			  //删除文件之前的钩子，参数为上传的文件和文件列表，若返回 false 或者返回 Promise 且被 reject，则停止删除
			  beforeRemove(file, fileList) {
				return this.$confirm(`确定移除 ${ file.name }？`);
			  },
			  //上传文件之前的钩子
			  beforeAvatarUpload(file) {
				  //const isPt = (file.type === 'image/jpeg' || file.type === 'image/png');
				  const isLt2M = file.size / 1024 / 1024 < 1;
		  
				 //  if (!isPt) {
					// this.$message.error('上传头像图片只能是 JPG或PNG 格式!');
				 //  }
				  if (!isLt2M) {
					this.$message.error('上传文件大小不能超过 1MB!');
				  }
				  return isLt2M //isPt && 
			  },

			categoryChange(item){
				console.log(item)
				//this.cate_id = item
			},
		    onCreated(editor) {
		        this.editor = Object.seal(editor) // 一定要用 Object.seal() ，否则会报错
		    },
			openOrderDialog() {
				this.dialogVisible = true;
				if (this.tableData.length === 0) {
					this.getList();
				}
			},
			onSearch() {
				this.page = 1;
				this.getList();
			},
			handleCurrentChange(val) {
				this.page = val;
				this.getList();
			},
			getList() {
				this.loading = true;
				request.post('/Order/orderbundleList', {
					page: this.page,
					status: '',
					search: this.searchForm,
				}).then(res => {
					this.loading = false;
					if (res.code == 1) {
						console.log(res.data, "弹框列表")
						this.tableData = res.data.rows;
						this.total = res.data.total;
					}
				}).catch(() => {
					this.loading = false;
				});
			},
			selectOrder(row) {
				this.selectedOrder = row;
				this.dialogVisible = false;
				// 自动填充标题 (可选)
				if (!this.title) {
					this.title = `[주문번호: ${row.platform_order_no }] 관련 문의`;
				}
			},
			submit(){
				//console.log(this.cate_id,"分类id")
				console.log(this.cate_value,"分类")
				console.log(this.title,"富文本内容")
				console.log(this.html,"富文本内容")
				console.log(this.file_url,"文件")
		
				if(!this.title){
					alert("제목 필수")
					return
				}
				if(this.title.length>=40){
					alert("제목 컨텐츠 과다")
					return
				}
				request.post('/Consult/addOneConsult',
					{
						title:this.title,
						cate_id:this.cate_value,
						content:this.html,
						file_url: this.file_url,
						order_id: this.selectedOrder ? this.selectedOrder.id : 0, // 关联订单ID
						//platform_order_no: this.selectedOrder ? (this.selectedOrder.platform_order_no || this.selectedOrder.order_no) : '',
						data_type: this.selectedOrder ? this.selectedOrder.data_type : ''
					}
				).then(response => {
					console.log(response,"121")			  
					if(response.code ==1){
						alert('Success！');
						console.log('提交成功！');
						this.$router.replace('/oneConsult');
					}else{
						alert(response.msg)
						return
					}
						
				});
				
				
			},
			cancel(){
				this.$router.replace('/oneConsult');
			},
			getCateName(){
				request.post('/Consult/getCateName',{}
				).then(res => {
					if(res.code ==1){
						this.category= res.data
					}
						
				});
			},
		},
		created(){
			this.getCateName()
		},
		mounted() {
			this.update_url = Constants.BASE_URL
			this.SERVER_URL = Constants.SERVER_URL
		    // 模拟 ajax 请求，异步渲染编辑器
		    // setTimeout(() => {
		    //     this.html = '<p>模拟 Ajax 异步设置内容 HTML</p>'
		    // }, 1500)
		},
		beforeDestroy() {
		    const editor = this.editor
		    if (editor == null) return
		    editor.destroy() // 组件销毁时，及时销毁编辑器
		},
		
	}
</script>
<style src="@wangeditor/editor/dist/css/style.css"></style>
<style scoped>
	.board-write h3 {
	    text-align: center;
	    font-size: 45px;
	    font-weight: bold;
	    color: var(--frontground-color);
	    padding: 0;
	    margin: 0 0 60px;
	}
	.list-top{
		border-top: 2px solid #000;
	}
	.list{
		padding:20px;
		border-bottom: 1px solid var(--border-color);
		display: flex;
		align-items: center;
	}
	.list .item-title{
		font-weight: bold;
	}
	.submit{
		padding:30px 0 20px;
		display: flex;
		justify-content: center;
		
	}
	
	@media (min-width: 992px) {
		.content-zsy{
			width: 1270px;
			margin: 2.5rem auto;
		}
	}
	@media (max-width: 768px) {
		.board-write h3 {
		    margin-top: 40px;
		}
		.list{
			margin: 0 10px;
		}
		
	}
</style>